import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  const [expand, updateExpanded] = useState(false);

  return (
    <Container fluid className="footer">
      
        <div className="footer-copywright">
          <h3>Copyright © {year} Baes Studio</h3>
          <h3>P.IVA 12766820018</h3>
          <h3>Professione esercitata ai sensi della legge 14 gennaio 2013 n.4</h3>
        </div>
        <div className="footer-body">
          <ul className="footer-icons">
{/*            <li className="social-icons">
              <a
                href="https://github.com"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
*/}
            <li className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=100087900502991"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillFacebook />
              </a>
            </li>
{/*            <li className="social-icons" >
              <a
                href="https://twitter.com"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiOutlineTwitter />
              </a>
            </li> 

            <li className="social-icons">
              <a
                href="https://www.linkedin.com"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
*/}
            <li className="social-icons">
              <a
                href="https://www.instagram.com/b.a.e.s._studio/"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>

          <Link
            as={Link}
            to="Home/privacy"
            onClick={() => updateExpanded(false)}
             >
            Privacy
          </Link>
        </div>
        <br></br> <br></br> <br></br>

    </Container>

  );
}

export default Footer;
